import React from 'react';
import '../css/dataTables.css';

const renderTableBody = (headers, data, action) => {
    let body = "";

    body = data?.map((register, index) => {
        const values = Object.values(register);

        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 100, maxWidth: 100 }}>
                    <button
                        type="button"
                        className="btn btn-sm"
                        onClick={() => action({ index })}
                        style={{
                            fontWeight: '500',
                            backgroundColor: "transparent",
                            color: "#EABF28"
                        }}
                    >
                        <i className="fas fa-check"></i>
                    </button>
                </td>

                {values?.map((val, i) => (
                    <td key={i}>
                        {val ?? ""}
                    </td>
                ))}
            </tr>
        );
    });

    return body;
};

const renderTable = (headers, data, action, switch1) => {

    let header = "";
    let body = "";

    if (headers?.length > 0) {
        header = (
            <tr>
                <td className="sticky-header table-header-yellow" style={{ width: 100, maxWidth: 100 }}></td>
                {headers?.map((h, index) => (
                    <td key={index} className="sticky-header table-header-yellow">
                        {h.title}
                    </td>
                ))}
            </tr>
        );
    }

    body = renderTableBody(headers, data, action, switch1);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableFormattedQueriesModal = (headers, data, action, switch1) => {

    return renderTable(headers, data, action, switch1);

}
